export default __webpack_public_path__ + "static/media/small-logo.ac240dd9.png";